import { Link, useLocation } from "react-router-dom";
import "../../PartnershipPage/Partnership.css";

import Logo1 from "../../../Assets/Images/Partnership-Logo/logo1.jpg";
import Logo2 from "../../../Assets/Images/Partnership-Logo/logo2.jpg";
import Logo3 from "../../../Assets/Images/Partnership-Logo/logo3.png";
import Logo4 from "../../../Assets/Images/Partnership-Logo/logo4.png";
import Logo5 from "../../../Assets/Images/Partnership-Logo/logo5.png";
import Logo6 from "../../../Assets/Images/Partnership-Logo/logo6.png";
import Logo7 from "../../../Assets/Images/Partnership-Logo/logo7.png";
import Logo8 from "../../../Assets/Images/Partnership-Logo/logo8.png";
import Logo9 from "../../../Assets/Images/Partnership-Logo/logo9.png";
import ArrowIcon from "../../../Assets/Icons/Vector.svg";

const logoSet1 = [
  Logo1,
  Logo2,
  Logo3,
  Logo4,
  Logo5,
  Logo6,
  Logo7,
  Logo8,
  Logo9,
];

const logoSet2 = [
  Logo9,
  Logo8,
  Logo7,
  Logo6,
  Logo5,
  Logo4,
  Logo3,
  Logo2,
  Logo1,
];

const TechPertnership = () => {
  const location = useLocation();
  const isTechnologiesPage = location.pathname === "/technologies";

  return (
    <div
      id="partner"
      className={`partnership-container ${
        isTechnologiesPage ? "partnership-container--compact" : ""
      }`}
    >
      <div className=" container">
        <div className="row">
          {/* Left Part */}
          <div className="col-lg-6  tab-view">
            <h2 className="partnership-title">
              Partnerships That Are Built Through Real Work
            </h2>
            <p className="partnership-text">
              Most partnerships are not established in meetings. They are built
              while solving problems together, dealing with pressure, and taking
              decisions when things are not clear. At Quad Theory Ltd we are
              cultivating partnerships based on long-term collaboration with
              technology providers, platforms and clients who value clarity and
              accountability.
            </p>
            <Link to="/contact-us/build-business">
              <button className="btn start-btn">
                Partner With Us
                <img
                  width={7}
                  className="space-left"
                  src={ArrowIcon}
                  alt="arrow--icon"
                />
              </button>
            </Link>
          </div>

          {/* Right Part */}
          <div className="col-lg-6">
            <div className="slider-container">
              <div className="logo-slider">
                {[...logoSet1, ...logoSet1].map((src, i) => (
                  <div key={i} className="logo-slide">
                    <img src={src} alt={`Partner Logo #${i + 1}`} />
                  </div>
                ))}
              </div>
            </div>

            <div className="slider-container">
              <div className="logo-slider uno-reverse">
                {[...logoSet2, ...logoSet2].map((src, i) => (
                  <div key={i} className="logo-slide">
                    <img src={src} alt={`Partner Logo #${i + 10}`} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechPertnership;
